// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__NlCxw","noInteraction":"EventWrapper_noInteraction__3E6L-","pointerPassthrough":"EventWrapper_pointerPassthrough__3Oruw"};